import type { RuntimeEnvironment } from './runtimeEnvironment';

export function formatVersionInfo(version?: string, build?: string): string {
  if (!version || !build) return '';
  return `v${version} (build ${build})`;
}

export function formatVersionWithEnvironment(
  version: string | undefined,
  build: string | undefined,
  environment: RuntimeEnvironment,
): string {
  const versionInfo = formatVersionInfo(version, build);
  if (!versionInfo) return '';

  if (environment === 'production') {
    return `${versionInfo} · prod`;
  }
  if (environment === 'staging') {
    return `${versionInfo} · staging`;
  }
  return `${versionInfo} · local`;
}
